module.exports = __webpack_public_path__ + "media/images/icon-svg/soep-401608974e4a95663a3aef9702b85b37.svg";